import { updateCookie, removeCookie } from '@/lib/cookie/client'
import { ONBOARDING_SESSION_STORAGE_KEY } from '@/constants/utils'
import { OnboardingStorageType } from '@/lib/types/utilsT'

const COOKIE_EXPIRY_MS = 3 * 60 * 60 * 1000

// The full payload (card, ownerInfo, ...) lives in sessionStorage — cookies cap out at ~4KB
// and this can grow well past that (long notes, multiple addresses/links, taxonomy keywords).
// Only these primitive fields are mirrored into a real cookie, since proxy.ts's onboarding
// gate and the checkout server component need to read something before hydration/sessionStorage
// is reachable.
const pickServerVisibleFields = (data: OnboardingStorageType) => ({
  planId: data.planId,
  billingCycle: data.billingCycle,
  activeContactId: data.activeContactId,
})

export const getOnboardingData = (): OnboardingStorageType | null => {
  if (typeof window === 'undefined') return null

  const raw = window.sessionStorage.getItem(ONBOARDING_SESSION_STORAGE_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as OnboardingStorageType
  } catch {
    return null
  }
}

export const updateOnboardingData = (data: Record<string, any>): OnboardingStorageType => {
  const merged = { ...getOnboardingData(), ...data } as OnboardingStorageType

  window.sessionStorage.setItem(ONBOARDING_SESSION_STORAGE_KEY, JSON.stringify(merged))
  updateCookie(ONBOARDING_SESSION_STORAGE_KEY, pickServerVisibleFields(merged), {
    expires: new Date(Date.now() + COOKIE_EXPIRY_MS),
  })

  return merged
}

export const removeOnboardingData = () => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(ONBOARDING_SESSION_STORAGE_KEY)
  }
  removeCookie(ONBOARDING_SESSION_STORAGE_KEY)
}
